import React from 'react'
import {useI18n} from '../../../i18n/I18nContext'
import {workerJobBank} from '../../../services/workerJobBank'

type Mentoring=NonNullable<Awaited<ReturnType<typeof workerJobBank.skillFocus>>['mentoring']>
export const JobSkillMentoring:React.FC<{mentoring:Mentoring}>=({mentoring})=>{
  const {t}=useI18n()
  const sources:Record<string,string>={deterministic:'Learning rules',llm_assisted:'AI-assisted Learning recommendation',human_coach:'Human coach recommendation',admin:'Learning administrator recommendation'}
  return <section className="stack" data-testid="job-skill-mentoring" style={{overflowWrap:'anywhere'}}>
    <h3>{t('Human coaching for this skill')}</h3>
    <p>{t('These are your existing Learning recommendations. They do not confirm coach availability or book a session.')}</p>
    {mentoring.recommendations.map(row=><article className="card stack" key={row.id}>
      <p className="helper">{t(sources[row.source]||'Learning recommendation')}</p><p>{row.reason}</p><p>{row.action}</p>
    </article>)}
    {mentoring.sharedRecommendations.map(row=><article className="card stack" key={row.id}>
      <strong>{row.title||t('Coaching recommendation shared with you')}</strong><p>{t('Shared with you through Learning. Confirm the next step with your existing Learning contact.')}</p>
    </article>)}
    {!mentoring.recommendations.length&&!mentoring.sharedRecommendations.length?<p>{t('No human coaching recommendation for this skill is currently shared with you.')}</p>:null}
  </section>
}
